import axiosInstance from "../../axiosInstance";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
export const getStudentFeed = createAsyncThunk(
  "get/studentFeed",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/userPostList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error.response.data);
    }
  }
);
const studentFeed = createSlice({
  name: "studentFeed",
  initialState: {
    feed: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getStudentFeed.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStudentFeed.fulfilled, (state, action) => {
      state.loading = false;
      state.feed = action.payload;
    });
    builder.addCase(getStudentFeed.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default studentFeed.reducer;
